module.exports = __webpack_public_path__ + "static/media/darksky-icon.c747c233.png";